var app_url = 'https://s.zlxm286.com';
// var app_url = 'http://m.shop.test';
// 如果是本地测试环境
if(process.env.NODE_ENV === 'development'){



}
// 如果是生产环境，h5环境下直接读取url
if(process.env.NODE_ENV === 'production'){



}

export default {
	/*服务器地址*/
	app_url: app_url,
	/*appid*/
	//app_id: 10008, // 南韵堂
	// app_id: 10010, // 南宗乐道
	// app_id: 10011, // 广西水果零售批发
	// app_id: 10009, // 珈健生物
	// app_id: 10056, // 勇者神鸭
	// app_id: 10007, // 众惠商贸城
	// app_id: 10065, // 天赐三宝
	// app_id: 10002, // 酒微达
	// app_id: 10069, // 和冠福国际
	// app_id: 10089, // 东盟生活圈
	 //app_id: 10076, // 安农六堡茶行
	// app_id: 10083, // 爱有方
	 //app_id: 10097,//叮咚生活优选
	 //app_id: 10118, // 卓来程序开发
	 // app_id: 10119, // 葛帝宴服务
	 app_id: 10128,
	//h5发布路径
	h5_addr: '/h5',
} 